import { Link, useLocation } from '@tanstack/react-router';
import {
  BarChart3,
  Bell,
  Columns3,
  FileText,
  LayoutDashboard,
  Settings,
  Users,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { NavItem } from '../../types/dashboard.types';

const iconMap: Record<string, typeof LayoutDashboard> = {
  'layout-dashboard': LayoutDashboard,
  'columns-3': Columns3,
  'file-text': FileText,
  users: Users,
  'bar-chart-3': BarChart3,
  bell: Bell,
  settings: Settings,
};

interface MobileDrawerNavSectionProps {
  label: string;
  items: NavItem[];
}

export function MobileDrawerNavSection({
  label,
  items,
}: MobileDrawerNavSectionProps) {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="flex flex-col gap-2">
      <span className="px-4 text-xs font-semibold uppercase tracking-wider text-foreground-inverse/50">
        {label}
      </span>
      {items.map((item) => {
        const isActive =
          location.pathname === item.path ||
          (item.path !== '/dashboard' &&
            location.pathname.startsWith(item.path));
        const Icon = iconMap[item.icon] || LayoutDashboard;

        return (
          <Link
            key={item.key}
            to={item.path}
            className={`flex w-full items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors ${
              isActive
                ? 'bg-accent-primary text-surface-inverse'
                : 'text-foreground-inverse hover:bg-white/10'
            }`}
          >
            <Icon className="h-5 w-5" />
            <span>{t(item.labelKey)}</span>
          </Link>
        );
      })}
    </div>
  );
}
